export const CATEGORY_TYPES = [
  'food',
  'beverage',
  'merchandise',
  'service',
  'meal_packages',
] as const;
export type CategoryType = (typeof CATEGORY_TYPES)[number];

export const CATEGORY_TYPE_LABELS: Record<CategoryType, string> = {
  food: 'Food',
  beverage: 'Beverage',
  merchandise: 'Merchandise',
  service: 'Service',
  meal_packages: 'Packages',
};

export const CATEGORY_TYPE_COLORS: Record<CategoryType, { bg: string; color: string }> = {
  food: { bg: '#E8F5E9', color: '#2C3E2D' },
  beverage: { bg: '#E3F2FD', color: '#0D47A1' },
  merchandise: { bg: '#FFF3E0', color: '#E65100' },
  service: { bg: '#F3E5F5', color: '#7B1FA2' },
  meal_packages: { bg: '#FFF8E1', color: '#E65100' },
};
